import React from "react";
import { LabeledImageCardCarousel, ILabeledCard } from "@organic-return/foundation-react/src/components/Blades/LabeledImageCardsCarousel"
import { graphql, useStaticQuery } from "gatsby";

const ImagesCardsCarousel = ({ module }) => {

    const data = useStaticQuery(graphql`
    query  {
        carousel: allAgilityImagesCardsCarousel {
          nodes {
            cards {
              customFields {
                image {
                  url
                }
                link {
                  href
                  text
                }
              }
              sizeAndAspect {
                customFields {
                  aspect
                  media
                  width
                }
              }
            }
            contentID      
          }
        }
    }
  `)

    const { customFields } = module;

    const carousel = data.carousel?.nodes?.find(item => item.contentID == module.contentID);
    let cards: ILabeledCard[] = []
    if (carousel) {
        cards = carousel.cards?.map((card): ILabeledCard => {
            const { image, link } = card.customFields
            return {
                image: image?.url && { url: image.url },
                link: link
            }
        })
    }

    return (
        <LabeledImageCardCarousel
            classNames="image-card-carousel"
            cards={cards}
            title={customFields.title}
            titleClassNames="w-full mx-auto max-w-screen-2xl"
            headingCTA={customFields.headingCTA}
        />
    );
}

export default ImagesCardsCarousel;